import React from 'react';
import PropTypes from 'prop-types';

const overlayStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(0,0,0,0.5)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 9999,
  pointerEvents: 'all',
};

const boxStyle = {
  backgroundColor: '#fff',
  padding: '1.5rem',
  borderRadius: '0.5rem',
  maxWidth: '400px',
  textAlign: 'center',
  boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
};

const alertStyle = {
  backgroundColor: '#fff3cd',
  color: '#856404',
  border: '1px solid #ffeeba',
  borderRadius: '0.25rem',
  padding: '1rem',
  fontSize: '1rem',
};

export const AlertModal = ({ children }) => (
  <div style={overlayStyle}>
    <div style={boxStyle}>
      <div style={alertStyle}>{children}</div>
    </div>
  </div>
);

AlertModal.propTypes = {
  children: PropTypes.string.isRequired,
};
